import apiFetch from '../apiFetch'

export default function (token, documentEntityType) {
  return apiFetch({ endPoint: `document/AllTypes?documentEntityType=${documentEntityType}`, method: 'GET', body: null, token: token })
}
